import { rangeCheck } from 'pages/Properties/CriteriaModal/Criteria/validation';
import * as Yup from 'yup';

export const ValidationSchema = Yup.object().shape({
  NumBedroomsRange: rangeCheck,
});
